<div class="times-trades" (window:beforeunload)="ngOnDestroy()" [ngClass]="{'new-window' : newWindow}">
  <div class="component-header">
    <span>NEGÓCIOS REALIZADOS</span>
    <div class="icons gridster-ignore-drag">
      <!-- <mat-icon svgIcon="chain"></mat-icon> TODO adicionar quando funcionalidade estiver implementada -->
      <mat-icon *ngIf="!newWindow && showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon disableWksChange *ngIf="!newWindow" svgIcon="close" (click)="removeItemFromWorkspace()"
        matTooltipPosition="above" [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="container-fluid table-content gridster-ignore-drag">
    <app-auction-hammer *ngIf="auctionHammer" [timeToOpen]="timeToOpen" [priceTheory]="priceTheory"
      [varTheory]="varTheory">
    </app-auction-hammer>
    <app-asset-input-header
      [symbolAutoComplete]="symbol" (onsymbolChanged)="selectAsset($event)" [lastTrade]="messageQuote.lastTrade"
      [coinVariation]="messageQuote.coinVariation" [showVariation]="showVariation" [hiddenInvalid]="hiddenInvalidActive" [variation]="messageQuote.variation"
      [dateLastNegotiation]="messageQuote.dateLastNegotiation" [hourLastTrade]="messageQuote.hourLastTrade" [timeUpdate]="messageQuote.timeUpdate"
      [company]="company" [image]="imgName"
    ></app-asset-input-header>
    <div class="spinner" *ngIf='loading'>
      <app-spinner-loading></app-spinner-loading>
    </div>
    <div class="row table-data" *ngIf='!loading && !hiddenInvalidActive'>
      <div class="header-table">
        <div class="line">
          <div class="hour">HORAS</div>
          <div class="price">PREÇO</div>
          <div class="size">QTD</div>
          <div class="buy-sell">COMPR.</div>
          <div class="buy-sell">VEND.</div>
          <div class="agr">AGR</div>
        </div>
      </div>
      <div class="col-12 grid-data" [ngClass]="{'theory': auctionHammer}">
        <div class="no-data-msg" *ngIf="hiddenInvalidActive">{{ msgNoData }}</div>
        <div class="no-data-msg" *ngIf="showEmpty && !hiddenInvalidActive">{{ msgEmpty }}</div>
        <table class="table-striped" *ngIf="!showEmpty">
          <tbody>
            <tr *ngFor="let row of rowOffersData let index=index;">
              <td class="hour">{{ row.time | date:'HH:mm:ss' }}</td>
              <td class="price">{{ row.price }}</td>
              <td class="size">{{ row.quantity }}</td>
              <td (mouseenter)="mouseEnterBrokerRow()" (mouseleave)="mouseLeaveBrokerRow()"
                class="buy-sell tooltip-cell">
                <span [ngStyle]="{'margin-top' : tooltiphover ? '4px' : '-7px'}">{{ row.buy_short }}</span>
                <div *ngIf="tooltiphover" matTooltipPosition="above" matTooltip="{{row.buy}}"></div>
              </td>
              <td (mouseenter)="mouseEnterBrokerRow()" (mouseleave)="mouseLeaveBrokerRow()"
                class="buy-sell tooltip-cell">
                <span [ngStyle]="{'margin-top' : tooltiphover ? '4px' : '-7px'}">{{ row.sell_short }}</span>
                <div *ngIf="tooltiphover" matTooltipPosition="above" matTooltip="{{row.sell}}"></div>
              </td>
              <td class="agr {{row.class}}">
                <span class="circle">{{ row.going_for_growth }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div (window:beforeunload)="closeSheet()"></div>
